import React from 'react'
import { connect } from 'react-redux'

import { Link} from "react-router-dom"
import './authenticate.css'
import axios from 'axios'
import {userList} from '../../redux/chatuser.redux.js'
import {authenticationFn} from '../../redux/chatuser.redux.js'
import {authenMsg} from '../../redux/chatuser.redux.js'
import { withRouter } from 'react-router-dom'


@withRouter
@connect(
  state=>state.chatuser,
  {userList,authenticationFn,authenMsg}
)
// 鉴定
class AuthenticatePC extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            authenticationVla: '',
			authenticationType:1,
			authenticationData:Object,
            gameOften:false,
            noticeMsg:{data1:'回归福利，心享俱乐部专享',data2:'特权礼包开放领取中'},
			wechatNum:'点击查看',
            wechatImg:'',
            gameInfo:'',
            showCode: false
        }
        
    	this.game_id = this.props.match.params.id
    }
    
  	handleChange(e){
        this.setState({
            authenticationVla:e.target.value
        })
    }
    
  	HandleSwitch(){
  		
        if(this.props.userlist.code===-1){
            var str = ''
            this.props.propsAuthenticationData&&this.props.propsAuthenticationData('')
            this.props.handleVla&&this.props.handleVla('')
            this.props.authenMsg('')
            
            this.props.location.state = ''
            
            
          this.props.authenticationFn('1')
          
            if(this.props.match.params.id){
                str = ''
            }else{
                str = '回归福利，心享俱乐部专享'
            }
            this.setState({
                authenticationType:1,
                authenticationVla:'',
                noticeMsg:{data1:str,data2:'特权礼包开放领取中'}
            })
            
            this.props.location.state = ''
        }else{

            const MyOrigin = window.location.origin
          this.pathname = MyOrigin +''+ this.props.location.pathname
          
          
          window.location.href ="/fapi/logoutB?returnUrl="+encodeURIComponent(this.pathname)
        }
        
    }
    handleAuthentication(){
        if(this.state.authenticationVla){
            if(this.state.authenticationVla.indexOf('<')>=0||this.state.authenticationVla.indexOf('>')>=0){
                alert('非法输入')
                return
            }
        }
        if(this.props.userlist.code===-1){
            var str = ''
            if(this.props.match.params.id){
                str = ''
            }else{
                str = '回归福利，心享俱乐部专享'
            }
            this.setState({
                noticeMsg:{data1:str,data2:'特权礼包开放领取中'}
            })
        }
        if(this.state.authenticationVla===''||!this.state.authenticationVla){return}
        this.authenticationdata()
    } 
    componentWillReceiveProps(nextProps){
  		
        if(this.props.userlist!==nextProps.userlist){
            
            if(nextProps.userlist.displayAccount){
              
              this.authenticationdata()
          }
        }
        this.setState({
            gameInfo:nextProps.gameInfo
        })
    }
    authenticationdata(){
        var oTime = parseInt(new Date().getTime()/1000)
        axios.get('/fapi/recom/authToken?time='+oTime+'&account='+this.state.authenticationVla)
            .then(res=>{
                if(res.data.return_code===0){
                    axios.get('/fapi/recom/authentication?token='+res.data.data.token+'&account='+this.state.authenticationVla)
                    .then(res=>{
                        if(res.data.return_code===0){
                          var idata = res.data.data
                          if(idata.game_often[0].game_id==='99999961'||idata.game_often[0].game_id==='9999960'||idata.game_often.length===0){
                              this.setState({
                                  gameOften:true
                              })
                            }else{
                                this.setState({
                                  gameOften:false
                              })
                            }
                            this.setState({
                                authenticationType:3,
                                authenticationData:res.data.data,
                                noticeMsg:{data1:'鉴定成功 欢迎回归',data2:'恭喜激活心享俱乐部回归特权'}
                            })
                          
                            
                            if(this.props.userlist.displayAccount){this.getManagerInfo()}
                            this.props.authenticationDataFn&&this.props.authenticationDataFn(res.data.data)
                            this.props.authenticationFn('3')

                            this.props.propsAuthenticationData&&this.props.propsAuthenticationData(res.data.data)
                        }else{
                          if(res.data.return_code===-1001901){
                              alert('鉴定账号过于频繁，请稍后尝试')
                                return
                            }
                            if(res.data.return_code===-1001900){
                                alert('鉴定账号异常，请联系客服')
                                return
                            }
                            this.setState({ 
                                authenticationType:2,
                                authenticationData:res.data.data,
                                noticeMsg:{data1:'很遗憾 鉴定失败',data2:'您未激活心享俱乐部回归特权'}
                            })
                            this.props.authenticationFn('2')
                            this.props.propsAuthenticationData&&this.props.propsAuthenticationData(res.data.data)
                        }
                  
                        //this.props.authenticationFn(this.state.authenticationVla)
                      this.props.handleVla&&this.props.handleVla(this.state.authenticationData)
                        
                        })
                }
            })
    }
    handleGameOften(item){
        this.props.authenMsg(this.state.authenticationData)
        this.props.history.push('/return-detail/'+item.game_id)
        //this.props.handleVla(this.state.authenticationData)
        
    }
    handleNoGameOften(){
        const iPath= this.props.location.pathname
        
        if(iPath==='/return-pc'){
          window.scrollTo(0,1000)
        }else{
             this.props.history.push('/return-pc')
             this.props.authenMsg(this.state.authenticationData)
        }
    }
  	getManagerInfo(){
        axios.get('/fapi/recom/getManagerInfo?account='+this.state.authenticationVla)
            .then(res=>{
                if(res.data.return_code===0){
                    if(res.data.data.manager){
                        this.setState({
                            wechatNum:res.data.data.manager.wechatID,
                            wechatImg:res.data.data.manager.qrcode_img
                        })
                    }
                }  
        })
    }
    handleAccount(){
		this.props.authenticationFn('')
		this.props.authenMsg('')
		this.props.handleVla&&this.props.handleVla('')
  		if(this.props.userlist.code===-1){
  			var str = ''
  			if(this.props.match.params.id){
  				str = ''
  			}else{
  				str = '回归福利，心享俱乐部专享'
  			}
  			this.setState({
  				authenticationType:1,
  				authenticationVla:'',
  				noticeMsg:{data1:str,data2:'特权礼包开放领取中'}
  			})
  		}else{
  			const MyOrigin = window.location.origin
			this.pathname = MyOrigin +''+ this.props.location.pathname						
			window.location.href ="/fapi/logoutB?returnUrl="+encodeURIComponent(this.pathname)
			return
  		}
            this.props.authenticationFn('1')
            this.props.propsAuthenticationData&&this.props.propsAuthenticationData('')
        }
      
        handleLogin(e){
            console.log(this.props.userlist)
            if(this.props.userlist.displayAccount){
                this.setState({
                    showCode:true
                },() => {
                    console.log(this.satate.showCode)
                })
                e.stopPropagation()
                return
            }		
            const pathname = this.props.location.pathname
            axios.get('/fapi/getLoginURL?redirect_url='+window.location.href)
            .then(res=>{
                    if(res.data.return_code==0){
                        window.location.href = res.data.redirect_url
                    }        
            })
        }
    render(){
        let state = this.state;
        return(
            <div className="authenticate-pc-box">
                <div className="title-box">
                    {/* 
                        未登录鉴权成功显示 - .logo & title1
                        其他状态显示 - .title1 & title2
                    */}
                    {
                        this.props.userlist.code === -1 && state.authenticationType === 3 ? 
                        <div>
                            <div className="games-logo">
                               
                                <img src="../../static/images/game89-icon.png" />
                            </div>
                            <div className="title1">{state.noticeMsg.data1}</div>
                        </div>: 
                        <div>
                            <div className="title1">{state.noticeMsg.data1}</div>
                            <div className="title2">{state.noticeMsg.data2}</div>
                        </div>
                    }
                    
                </div>
                <div className="jq-box">
                        {this.game_id==='89'?<div className="games-logo lzg-icon"></div>:''}
                        {this.game_id==='791000306'?<div className="games-logo gmys-icon"></div>:''}
                        {this.game_id==='78'?<div className="games-logo yhzt-icon"></div>:''}
							
                        {/** 未登录 */}
                        {
                            state.authenticationType === 1 ? 
                            <div className="unLogin-box">
                                <div className="login-logo"></div>
                                    <div>
                                        <input className="inp" type="text" placeholder="请输入盛大游戏通行证账号" onChange={(e) => this.handleChange(e)}></input>
                                        <button className="jq-btn" onClick={() => this.handleAuthentication()}>立即鉴定领取回归特权</button>
                                    </div>
                            </div> : null
                        
                        }
                        {/* 鉴权成功 */}
                        {
                            state.authenticationType === 3 ?
                            <div className="jqcg-box">
                                <div className="left"></div>
                                <div className="right">
                                    <p>
                                        <span>
                                        {
                                            this.props.userlist.code===-1?
                                            state.authenticationData.t_account:
                                            state.authenticationData.account
                                        }
                                        </span>
                                        <i className="tq-icon"></i>
                                    </p>
                                    <p>心享俱乐部等级：<span>{state.authenticationData.level}</span></p>
                                    {
                                        !state.gameOften&&<p>曾经玩过的游戏：
                                            {
                                                state.authenticationData.game_often.map((item,i)=>(

                                                    <span 
                                                        key={i}
                                                        onClick={()=>this.handleGameOften(item)}
                                                    >{item.game_name}</span>
                                                ))
                                            }
                                        </p>
                                    }
                                    {
                                        state.gameOften&&<div className="no-game-often" onClick={()=>this.handleNoGameOften()}>还未玩过盛趣游戏，点击查看游戏列表</div>
                                    }
                                    {
                                        state.authenticationData.exsit_manager===1||state.wechatNum!==''?
                                        <p className="er-code-ifo">客服经理微信号：<span onClick={(e)=>this.handleLogin(e)}>{state.wechatNum}</span>
                                        </p>:null
                                    }
                                    <p>&emsp;账号点券余额：<span>传奇世界</span></p>
                                </div>
                                <div className="switchAccount"  onClick={()=>this.HandleSwitch()}>切换账号</div>
                                
                                {
                                    state.showCode && <div className="ercode-box">
                                        <img src={state.wachatImg}></img>
                                    </div>
                                }
                                
                            </div>
                            : null
                        }
                        {/* 鉴定失败 */}
                        {   state.authenticationType === 2 ?
                            <div className="jdsb-box">
                                <div className="jdsb-userinfo">
                                    <div className="tx"></div>
                                    <div className="name">
                                        <span>
                                        {
                                            this.props.userlist.code===-1?
                                            state.authenticationData.t_account:
                                            state.authenticationData.account
                                        }
                                        </span>
                                        <i className="sb-icon"></i>
                                    </div>
                                </div>
                                <button className="cxjq-btn" onClick={() => this.handleAccount()}>切换账号 重新鉴定</button>
                            </div>
                            : null
                        }
                </div>
            </div>
        )
    }
}

export default AuthenticatePC;



// WEBPACK FOOTER //
// ./src/component/authenticate-pc/authenticate.js